import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

import Header from "@/components/Header";
import SideComplaintsPanel from "@/components/SideComplaintsPanel";
import CommandSearch from "@/components/CommandSearch";
import RegisterModal from "@/components/RegisterModal";
import ScanModal from "@/components/ScanModal";
import { UserProvider } from "@/lib/UserContext";
import Dashboard from "@/pages/Dashboard";
import SearchPage from "@/pages/SearchPage";
import ProductDetail from "@/pages/ProductDetail";
import ComplaintsPage from "@/pages/ComplaintsPage";
import AlertsPage from "@/pages/AlertsPage";
import ComparePage from "@/pages/ComparePage";
import MessagesPage from "@/pages/MessagesPage";

function Layout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "/" && !/(INPUT|TEXTAREA|SELECT)/.test(document.activeElement?.tagName || "")) {
        e.preventDefault();
        setSearchOpen(true);
      }
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="App min-h-screen flex flex-col bg-[#F7F5F0]">
      <Header
        onOpenSearch={() => setSearchOpen(true)}
        onOpenScan={() => setScanOpen(true)}
        onOpenRegister={() => setRegisterOpen(true)}
      />
      <div className="flex flex-1">
        <main className="flex-1 min-w-0">
          <Outlet context={{ openScan: () => setScanOpen(true), openRegister: () => setRegisterOpen(true) }} />
        </main>
        <SideComplaintsPanel />
      </div>
      <CommandSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
      <RegisterModal open={registerOpen} onClose={() => setRegisterOpen(false)} />
      <ScanModal open={scanOpen} onClose={() => setScanOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/complaints" element={<ComplaintsPage />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/messages" element={<MessagesPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
